import React, { useState, useEffect } from "react";
import { inputFormat, billPlease, moneyFormat, countDishes } from "../../ultil";
import TipShipperOrder from "../StoreCart/TipShipperOrder";
import Modal from "react-modal";
import _ from "lodash";
import toastr from 'toastr';
import Swal from "sweetalert2";
import { modalStyleCenter, modalStyleBottom, style } from "../../style";
import MenuItem from "./MenuItem";
import InputCustom from "../Input/InputCustom";
import TextTitle from "../Text/TextTitle";
import TextTitle1 from "../Text/TextTitle1";
import TextBody from "../Text/TextBody";
import TextBody2 from "../Text/TextBody2";
import TextHead from "../Text/TextHead";
import TextPrice from "../Text/TextPrice";
import TextPriceOld from "../Text/TextPriceOld";
import TextQuantity from "../Text/TextQuantity";
import TextOutOfStock from "../Text/TextOutOfStock";
import {
  AppBar,
  Box,
  Divider,
  Paper,
  Tab,
  Tabs,
  Typography,
  IconButton,
  Grid,
  Button,
  ButtonBase,
  ButtonGroup,
  Toolbar,
  Slide,
  TextField,
  FormGroup,
  FormControlLabel,
  Checkbox,
  RadioGroup,
  Radio
} from '@mui/material';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import TextSnippetIcon from '@mui/icons-material/TextSnippet';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
const MTAMap = React.lazy(() =>
  import("../MTAMap")
)
const noFunc = () => {}

const dayOfWeek = ['Chủ nhật', 'Thứ hai', 'Thứ ba', 'Thứ tư', 'Thứ năm', 'Thứ sáu', 'Thứ bảy']

const Cart = ({
  setAddCart,
  addCart,
  setIsCart,
  createOder,
  distanceMoney,
  setNote,
  note,
  listStore,
  configErrandFee,
  setTip,
  tip,
  openModelPromote,
  count,
  discountMoney,
  orderType,
  moneyCod,
  nameAddressUser="",
  setIsOpenAddress,
  promoteCode,
  noteStore,
  setNoteStore,
  setNameAddressUser,
  subName,
  setSubName,
  configPromote,
  countPromoteStore,
  openModelPromoteStore,
  promoteCodeStore,
  discountMoneyStore,
  user,
  setIsLogin,
  openModelLogin,
  setMessagePopup,
  isChekIsAvailable,
  namePromoteCodeStore,
  namePromoteCode,
  modalIsOpenTopping,
  setIsOpenTopping,
  isEditTopping,
  setIsEditTopping,
  indexEditTopping,
  setIndexEditTopping,
  setDataDetail,
  isEditToppingInCart,
  setIsEditToppingInCart
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [openPayment, setOpenPayment] = useState(false);

  const btnAddToCard = (data, idx) => {
    addCart[idx].quantity++;
    setAddCart(_.cloneDeep(addCart));
    localStorage.setItem("list-carts", JSON.stringify(addCart));
  };

  const btnShowModal = () => {
    if (_.isEmpty(user)) {
      setMessagePopup("Bạn vui lòng đăng nhập để xem phí ship");
      openModelLogin();
    } else {
      if (distanceMoney.money) {
        setIsOpen(true);
      }
    }
  };

  const closeModal = () => {
    setIsOpen(false);
  };
  const closeModalPayment = () => {
    setOpenPayment(false);
  };
  const OpenModalPayment = () => {
    setOpenPayment(true);
  };
  const removeFromCart = (data, idx) => {
    for (var i = 0; i < listStore.length; i++) {
      if (listStore[i]._id === data._id) {
        listStore[i].quantity = data.quantity - 1;
      }
    }

    if (addCart[idx].quantity > 1) {
      addCart[idx].quantity--;
    } else {
      addCart.splice(idx, 1);
    }
    if (addCart.length === 0) {
      comeBack();
    }
    localStorage.setItem("list-carts", JSON.stringify(addCart));
    setAddCart(_.cloneDeep(addCart));
  };
  const comeBack = () => {
    setIsCart(0);
    localStorage.setItem("screen", 0);
  };
  const btnEditAddress = () => {
    if (_.isEmpty(user)) {
      openModelLogin();
      setMessagePopup("Bạn vui lòng đăng nhập để nhập địa chỉ giao hàng");
    } else {
      setIsOpenAddress(true);
      const subname = localStorage.getItem("sub-name");
      setSubName(_.cloneDeep(subname));
      const dataLocation = JSON.parse(localStorage.getItem("location"));
      if (dataLocation != null) {
        setNameAddressUser(_.cloneDeep(dataLocation.address));
      }
    }
  };
  useEffect(() => {
    // var objDiv = document.getElementById("parentDiv");
    // objDiv.scrollTop = objDiv.scrollHeight;
    const subname = localStorage.getItem("sub-name");
    setSubName(_.cloneDeep(subname));
  }, []);

  const billTopping = dataDetail => {
    let sum = dataDetail.pricePromote;
    if (dataDetail.toppingSelected) {
      dataDetail.toppingSelected.map((item, i) => {
        item.toppingSelected.map((t, j) => {
          sum += t.price * t.quantity;
        });
      });
    }
    return sum * dataDetail.quantity;
  };

  const editTopping = (data, idx) => {
    setIndexEditTopping(idx);
    setIsEditTopping(true);
    setIsOpenTopping(true);
    setDataDetail(data);
    document.body.style.overflow = "auto";
    setIsEditToppingInCart(true);
    comeBack();
  };

  const requireLogin = _.isEmpty(user) ? 'Đăng nhập để xem' : false

  return (<>
    <Box sx={style}>
      <Box sx={{position: 'relative', marginBottom: '106px'}}>
        <AppBar
          position="sticky"
          color="inherit"
        >
          <Toolbar sx={{minHeight: '52px'}}>
            <IconButton
              size="large"
              edge="start"
              color="inherit"
              aria-label="menu"
              onClick={comeBack}
            >
              <ArrowBackIcon fontSize="large"/>
            </IconButton>
            <TextTitle1 variant="h5" component="div">
              Giỏ hàng
            </TextTitle1>

          </Toolbar>
        </AppBar>
        <Box sx={{ bgcolor: '#ffffff'}} px={2} pt={2}>
          <Box onClick={() => btnEditAddress()} pb={2}>
          <Box sx={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer'}}>
            <TextBody component="div"><i className="icon-location" style={{color: 'rgba(21, 137, 216, 1)', fontSize: '24px'}}/></TextBody>
            <Box sx={{flexGrow:  1}}>
              <Box sx={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                <Box px={2} sx={{flexGrow:  1}}>
                <TextBody className="line-clamp-1">
                  {nameAddressUser.split(',')[0] || 'Vị trí giao hàng'}
                </TextBody>
                <TextBody2 className="line-clamp-1" color="#929394">
                  {nameAddressUser}
                </TextBody2>
                </Box>
                <IconButton>
                  <ArrowForwardIosIcon/>
                </IconButton>
              </Box>
              <Box px={2}>
              <TextBody2
                sx={{my: 1, bgcolor: '#F5F6FA', width: '100%', boxShadow: 'none', borderRadius: '16px', display: 'flex', padding: '6px 12px 8px 12px'}}
                children={subName || <span style={{color: '#929394'}}>Địa chỉ chi tiết nếu có</span>}
              />
              </Box>

            </Box>


          </Box>
          </Box>
          <Divider/>
          <InputCustom
            icon={<i className="icon-document-text" style={{fontSize: '20px', paddingBottom: '4px'}}/>}
            sx={{my: 1, bgcolor: '#ffffff', width: '100%', boxShadow: 'none', display: 'flex', justifyContent: 'center', alignItems: 'center'}}
            placeholder="Thêm ghi chú cho tài xế"
            value={note}
            onChange={e => {
              setNote(e.target.value);
            }}
          />
        </Box>
        <Box sx={{ bgcolor: '#ffffff'}} mt={1} px={2} pt={2}>
          <Box sx={{display: 'flex', alignItems: 'center'}} mb={2}>
            <Box sx={{flexGrow: 1}}>
              <TextBody>Chọn thêm món ngon</TextBody>
              <TextBody2 color="#929394">Chọn thêm món khác nếu bạn muốn</TextBody2>
            </Box>
            <Box>
              <ButtonBase onClick={comeBack} sx={{borderRadius: '20px', bgcolor: '#ffffff', color: '#1589D8', border: '1px solid #1589D8', padding: '8px 12px', fontSize: '16px'}}>
                Thêm món
              </ButtonBase>
            </Box>
          </Box>
          <Divider/>
          <Box sx={{display: 'flex', flexDirection: 'column'}}>
          {
            !_.isEmpty(addCart) ?
            addCart.map((item, i)=><MenuItem
              key={i}
              lastItem={i === (addCart.length - 1)}
              dataItem={item}
              quantity={item.quantity}
              onClickItem={()=>!_.isEmpty(item.topping) ? editTopping(item, i) : null }
              onClickAdd={()=>btnAddToCard(item, i)}
              onClickMinus={()=>removeFromCart(item, i)}
            />)
            :null
          }
          </Box>
          <InputCustom
            icon={<i className="icon-document-text" style={{fontSize: '20px', paddingBottom: '4px'}}/>}
            sx={{my: 1, bgcolor: '#ffffff', width: '100%', boxShadow: 'none', display: 'flex', justifyContent: 'center', alignItems: 'center'}}
            placeholder="Thêm lưu ý cho quán"
            value={noteStore}
            onChange={e => {
              setNoteStore(e.target.value);
            }}
          />
        </Box>

        <Box sx={{ bgcolor: '#ffffff'}} mt={1} p={2}>
        <TextBody mb={1}>Tóm tắt thanh toán</TextBody>
        <Box sx={{display: 'flex'}} my={1}>
        <TextBody2 className="line-clamp-1" sx={{flexGrow: 1}}>Tạm tính ({countDishes(addCart)} món)</TextBody2>
        <TextBody2 sx={{minWidth: '82px', textAlign: 'right'}}>{moneyFormat(billPlease(addCart))}</TextBody2>
        </Box>
        {billPlease(addCart) - discountMoneyStore >
          orderType.depositNotAuthen &&
        user.shop &&
        user.shop.isAuthen === 0 ? (
          <p style={{ fontSize: "12px", color: "red" }}>
            {orderType.messageNotAuthen}
          </p>
        ) : null}
        <Box onClick={btnShowModal} sx={{display: 'flex', cursor: 'pointer'}} my={1}>
        <TextBody2 className="line-clamp-1" sx={{flexGrow: 1}}>Phí giao hàng <i className="fa fa-info-circle"/> {orderType.priceIncrease > 1 && (
          <i
          style={{ paddingLeft: "5px" }}
          className="fa fa-flash price-increase-icon"
          />
        )}: {requireLogin || `${distanceMoney.distance}km`}</TextBody2>
        <TextBody2 sx={{minWidth: '82px', textAlign: 'right'}}>{moneyFormat(distanceMoney.money + (orderType.resourceFee || 0) + moneyCod + tip)}</TextBody2>
        </Box>
        {
          tip?
          <Box sx={{display: 'flex'}} my={1}>
          <TextBody2 className="line-clamp-1" sx={{flexGrow: 1}}>Tip tài xế</TextBody2>
          <TextBody2 sx={{minWidth: '82px', textAlign: 'right'}}>{moneyFormat(tip)}</TextBody2>
          </Box>
          :null
        }
        {
          discountMoneyStore || promoteCodeStore?
          <Box sx={{display: 'flex'}} my={1}>
          <TextBody2 className="line-clamp-1" color="#1589D8" sx={{flexGrow: 1}}>{promoteCodeStore}</TextBody2>
          <TextBody2 color="#1589D8" sx={{minWidth: '82px', textAlign: 'right'}}>- {moneyFormat(discountMoneyStore)}</TextBody2>
          </Box>
          :null
        }

        {
          discountMoney || promoteCode?
          <Box sx={{display: 'flex'}} my={1}>
          <TextBody2 className="line-clamp-1" color="#1589D8" sx={{flexGrow: 1}}>{promoteCode}</TextBody2>
          <TextBody2 color="#1589D8" sx={{minWidth: '82px', textAlign: 'right'}}>- {moneyFormat(discountMoney)}</TextBody2>
          </Box>
          :null
        }

        <Divider/>
        <Box sx={{display: 'flex'}} my={1}>
        <TextBody2 className="line-clamp-1" sx={{flexGrow: 1}}><strong>Tổng thanh toán</strong></TextBody2>
        <TextBody2 sx={{minWidth: '82px', textAlign: 'right'}}><strong>{requireLogin || moneyFormat(billPlease(addCart) + (distanceMoney.money + (orderType.resourceFee || 0) + moneyCod + tip) - discountMoney - discountMoneyStore)}</strong></TextBody2>
        </Box>
        </Box>

        <Box sx={{ bgcolor: '#ffffff'}} mt={1} p={2}>
          <TextBody mb={2}>Thông tin hóa đơn</TextBody>
          <Box onClick={()=>toastr.warning('Hiện tại đặt đơn trên web chỉ hỗ trợ thanh toán bằng tiền mặt')} sx={{display: 'flex', cursor: 'pointer'}} my={1}>
            <TextBody2 className="line-clamp-1" sx={{flexGrow: 1}}><img
              style={{ width: "30px", paddingRight: "5px" }}
              src="https://media.heyu.asia/uploads/valentine/2020-04-04-thanhtoantienmat2.png"
            ></img>
            Tiền mặt</TextBody2>
            <TextBody2 sx={{minWidth: '82px', textAlign: 'right'}}>
            <IconButton sx={{padding: '0px'}}>
              <ArrowForwardIosIcon/>
            </IconButton>
            </TextBody2>
          </Box>
          <Divider/>
          <Box onClick={() => openModelPromoteStore()} sx={{display: 'flex', cursor: 'pointer'}} my={1}>
            <i className="icon-ticket-discount" style={{color:'#1589D8', fontSize: '24px', marginRight: '5px'}}/>
            <TextBody2 className="line-clamp-1" sx={{flexGrow: 1}}>Ưu đãi cửa hàng {requireLogin || (namePromoteCodeStore ? namePromoteCodeStore : countPromoteStore ? `${countPromoteStore} ưu đãi chưa sử dụng` : null)} </TextBody2>
            <TextBody2 sx={{minWidth: '82px', textAlign: 'right'}}>
            <IconButton sx={{padding: '0px'}}>
              <ArrowForwardIosIcon/>
            </IconButton>
            </TextBody2>
          </Box>
          <Divider/>
          <Box onClick={() => openModelPromote()} sx={{display: 'flex', cursor: 'pointer'}} my={1}>
          <i className="icon-ticket-discount" style={{color:'#1589D8', fontSize: '24px', marginRight: '5px'}}/>
            <TextBody2 className="line-clamp-1" sx={{flexGrow: 1}}>Ưu dãi HeyU {requireLogin || (namePromoteCode ? namePromoteCode : count ? `${count} ưu đãi chưa sử dụng` : null)} </TextBody2>
            <TextBody2 sx={{minWidth: '82px', textAlign: 'right'}}>
            <IconButton sx={{padding: '0px'}}>
              <ArrowForwardIosIcon/>
            </IconButton>
            </TextBody2>
          </Box>
          <Divider/>
          {
            !_.isEmpty(user) ?(
            <Box sx={{display: 'flex'}} my={1}>
              <TipShipperOrder tip={tip} setTip={setTip} />
            </Box>)
            :null
          }
          <TextBody2
            component="div"
            color="#1589D8"
            sx={{ fontWeight: "bold", textAlign: 'center', width: '100%' }}
          >
            <a href="https://heyu.vn/terms-app/"target="_blank" >Điều khoản, chính sách đền bù</a>
          </TextBody2>
        </Box>

        <Box sx={{position: 'fixed', width: '100%', maxWidth: '600px', bottom: 0, zIndex: 1, bgcolor: '#ffffff', boxShadow: '0px -2px 8px rgba(92, 83, 83, 0.08)'}}>
          <Box sx={{display: 'flex'}} px={2} pt={2}>
          <TextBody2 className="line-clamp-1" sx={{flexGrow: 1}}><strong>Tổng cộng</strong></TextBody2>
          <TextBody2 sx={{minWidth: '82px', textAlign: 'right'}}><strong>{moneyFormat(billPlease(addCart) + (distanceMoney.money + (orderType.resourceFee || 0) + moneyCod + tip) - discountMoney - discountMoneyStore)}</strong></TextBody2>
          </Box>
          <Box sx={{width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '12px 16px'}}>
            <Button disabled={!isChekIsAvailable} onClick={createOder} fullWidth size="large" variant="contained" sx={{borderRadius: '16px', fontSize: '16px', textTransform: 'none', bgcolor: '#1589D8'}}>
              Đặt đơn
            </Button>
          </Box>
        </Box>
      </Box>
    </Box>
    <Modal
      isOpen={isOpen}
      style={modalStyleCenter}
      onRequestClose={closeModal}
      ariaHideApp={false}
    >
    <Box sx={style}>
      <Box sx={{position: 'relative'}}>
        <AppBar
          position="sticky"
          color="inherit"
        >
          <Toolbar sx={{minHeight: '52px'}}>
            <IconButton
              size="large"
              edge="start"
              color="inherit"
              aria-label="menu"
              onClick={closeModal}
            >
              <ArrowBackIcon fontSize="large"/>
            </IconButton>
            <TextTitle1 variant="h5" component="div">
              Phí dịch vụ {orderType.priceIncrease > 1 && (
                <i
                  style={{ paddingLeft: "5px" }}
                  className="fa fa-flash price-increase-icon"
                />
              )}
            </TextTitle1>

          </Toolbar>
        </AppBar>
        <Box sx={{ bgcolor: '#ffffff'}} p={2}>

        {orderType.priceIncrease > 1 && (
          <p
            style={{fontSize: "16px",fontWeight: "bold" }}
            className="text-center"
          >
            Phí dịch vụ tăng khi đặt đơn vào khoảng thời gian này
        </p>
        )}
        <Box sx={{display: 'flex'}} my={1}>
          <TextBody2 className="line-clamp-1" sx={{flexGrow: 1}}>Phí ship</TextBody2>
          <TextBody2 sx={{minWidth: '82px', textAlign: 'right'}}>{orderType.priceIncrease > 1 && (
            <i
              style={{ paddingLeft: "5px" }}
              className="fa fa-flash price-increase-icon"
            />
          )} {moneyFormat(distanceMoney.money || 0)}</TextBody2>
        </Box>
        <Divider/>
        {moneyCod != 0 ? (<>
          <Box sx={{display: 'flex'}} my={1}>
            <TextBody2 className="line-clamp-1" sx={{flexGrow: 1}}>Phí thu hộ</TextBody2>
            <TextBody2 sx={{minWidth: '82px', textAlign: 'right'}}>{moneyFormat(moneyCod)}</TextBody2>
          </Box>
          <Divider/>
          </>
        ) : null}

        {tip != 0 ? (<>
          <Box sx={{display: 'flex'}} my={1}>
            <TextBody2 className="line-clamp-1" sx={{flexGrow: 1}}>Tiền tip</TextBody2>
            <TextBody2 sx={{minWidth: '82px', textAlign: 'right'}}>{moneyFormat(tip)}</TextBody2>
          </Box>
          <Divider/>
          </>
        ) : null}
        {orderType.resourceFee ? (<>
          <Box sx={{display: 'flex'}} my={1}>
            <TextBody2 className="line-clamp-1" sx={{flexGrow: 1}}>Phí tài nguyên</TextBody2>
            <TextBody2 sx={{minWidth: '82px', textAlign: 'right'}}>{moneyFormat(orderType.resourceFee)}</TextBody2>
          </Box>
          <Divider/>
          </>
        ) : null}
        {discountMoney ? (<>
          <Box sx={{display: 'flex'}} my={1}>
            <TextBody2 className="line-clamp-1" sx={{flexGrow: 1}}>Khuyến mại</TextBody2>
            <TextBody2 sx={{minWidth: '82px', textAlign: 'right'}}>{moneyFormat(discountMoney)}</TextBody2>
          </Box>
          <Divider/>
          </>
        ) : null}
        <Box sx={{display: 'flex'}} my={1}>
          <TextBody2 className="line-clamp-1" sx={{flexGrow: 1}}><strong>Tổng</strong></TextBody2>
          <TextBody2 sx={{minWidth: '82px', textAlign: 'right'}}><strong>{moneyFormat((distanceMoney.money +(orderType.resourceFee || 0) + moneyCod + tip - discountMoney))}</strong></TextBody2>
        </Box>
        </Box>
        <Box sx={{width: '100%', display: 'flex', justifyContent: 'space-around', alignItems: 'center', padding: '12px 16px', bgcolor: '#ffffff'}}>
          <Button onClick={closeModal} size="large" variant="contained" sx={{borderRadius: '16px', fontSize: '16px', textTransform: 'none', bgcolor: '#1589D8'}}>
            Xác nhận
          </Button>
        </Box>
      </Box>
    </Box>
    </Modal>
  </>);
};
export default Cart;
